import * as React from 'react';

import AiDisclaimerModule from 'bundles/unified-description-page-common/components/modules/ai-disclaimer/AiDisclaimerModule';
import type { ConsumerCourseMarketingPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCourseMarketingPageQuery';
import type { ConsumerCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerCoursePageQuery';
import type { EnterpriseCoursePageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/EnterpriseCoursePageQuery';

type Props = {
  pageData:
    | ConsumerCoursePageFieldsFragment
    | EnterpriseCoursePageFieldsFragment
    | ConsumerCourseMarketingPageFieldsFragment;
};

const hasAiGradedAssignments = (
  pageData:
    | ConsumerCoursePageFieldsFragment
    | EnterpriseCoursePageFieldsFragment
    | ConsumerCourseMarketingPageFieldsFragment
): boolean => {
  if (!pageData.material?.weeks) return false;

  return pageData.material.weeks.some(
    (week) => week.assessments?.some((assessment) => assessment.containsAiGrading) || false
  );
};

const AiDisclaimerModuleRenderer = ({ pageData }: Props) => {
  if (!hasAiGradedAssignments(pageData)) {
    return null;
  }

  return <AiDisclaimerModule />;
};

export default AiDisclaimerModuleRenderer;
